module.exports = __webpack_public_path__ + "img/flag-2.504818f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise-countries/flag-2.png
// module id = 720
// module chunks = 1